export default __webpack_public_path__ + "static/media/012.db068e31.jpg";